import { render, staticRenderFns } from "./ServiceRateCard.vue?vue&type=template&id=1cf31f20&scoped=true&"
import script from "./ServiceRateCard.vue?vue&type=script&lang=js&"
export * from "./ServiceRateCard.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRateCard.vue?vue&type=style&index=0&id=1cf31f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf31f20",
  null
  
)

export default component.exports